/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect} from 'react'
import NavigationBar from '../components/NavBar'
import 'react-dropdown/style.css';
import axios from 'axios'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { 
    selectDrivers,
    addDrivers
} from '../features/drivers/driversSlice'
import {
    addImages, 
    selectImages
} from '../features/imagesSliceFile/imagesSlice'
import {
    addRota,
    selectRotaData
} from '../features/rota/rotaSlice'
import {
    addSchedule, 
    selectSchedule
} from '../features/schedule/scheduleSlice'
import {
    addVehicle, 
    selectVehicles
} from '../features/vehicles/vehiclesSlice'

var myInterval

var driversObj = {}

var vehicleObj = {}

var displayObj = {
    'DBS2': 'Bristol',
    'DSN1': 'Swindon',
    'DEX2': 'Exeter',
    'DXP1': 'Plymouth',
    'DCF1': 'Truro'
}

const determineOffboarded = (offboradedContent, selectedFunctionDate) => {
    switch (offboradedContent) {
        case 'OffboardedForever':
            return false
        case 'Active':
            return true
        case 'verified':
            return true
        case null:
            return true        
        default:
            return false
    }
}
const HomeTwo = (props) => {
    useEffect( () => {
        if (props.superUser) {

        } else {
            async function postData(url = '', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                });
                return response ? response.json() : console.log('no reponse')
            };
            async function putData(url = '', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'PUT', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                });
                return response ? response.json() : console.log('no reponse')
            };
            postData('https://backendpajamas.herokuapp.com/tracker/', {
                ID: props.user_id
            }).then( response => {
                let theDate = new Date()
                let theTime = `${theDate.getHours()}:${theDate.getMinutes()}:${theDate.getSeconds()}`
                if (response.data) {
                    response.data.forEach( ele => {
                        if (ele.date === new Date().toDateString()) {
                            let localPagesList = [...ele.pages_list, `${ele.pages_list.length}+home+${theTime}`]
                            putData(`https://backendpajamas.herokuapp.com/trackeradditions/${ele._id}/`, {
                                pages_list: localPagesList
                            })
                        }
                    })
                }
            })
        }
    }, [])
    const dispatch = useDispatch();
    var CryptoJS = require("crypto-js");
    const [ currentDate, setCurrentDate ] = useState(new Date())
    const [ selectedDate, setSelectedDate ] = useState(new Date())
    const [ selectedCity, setSelectedCity ] = useState('DBS2')
    const [ schedule, setSchedule ] = useState(null)
    const [ loadGate, setLoadGate ] = useState(0)
    const [ theDateRandom, setTheDateRandom ] = useState(new Date())
    const [ data, setData ] = useState(null)
    const [ verifiedDocumentsDivs, setVerifiedDocumentsDivs ] = useState(null)
    const [ expirationList, setExpirationList ] = useState([])
    const [ quoteOfDay, setQuoteOfDay ] = useState(null)
    const [ quoteOfDayArray, setQuoteOfDayArray ] = useState([])
    const [ todaysDrivers, setTodaysDrivers ] = useState(null)

    // redux stuff
    const reduxDrivers = useSelector(selectDrivers)
    const rotaData = useSelector(selectRotaData)
    const imageData = useSelector(selectImages)
    const scheduleData = useSelector(selectSchedule)
    const reduxVehicles = useSelector(selectVehicles)

    useEffect( () => {
        if (props.station) {
            if (props.station.length > 0) {
                setSelectedCity(props.station[0])
                // setSelectedCity()
            }
        }
    }, [])

    // view the redux state
    useEffect( () => {
        if (scheduleData) {
            if (reduxDrivers.length > 0 && rotaData && imageData.length > 0 && reduxVehicles.length > 0) {
                reduxDrivers.forEach( driver => {
                    if (determineOffboarded(driver.status)) {
                        driversObj[`${driver.driver_id}`] = {
                            name: driver.name,
                            id: driver.driver_id,
                            location: driver.location
                        }
                    }
                })
                reduxVehicles.forEach( vehicle => {
                    if (!vehicle.offboarded) {
                        vehicleObj[`${vehicle.vehicle_id}`] = vehicle.registration
                    }
                })
                let myDate = new Date()
                while (myDate.getDay() > 0) {
                    myDate.setDate(myDate.getDate() - 1)
                }
                setSelectedDate(myDate)
                setSchedule(scheduleData)
                setData(imageData)
                async function getData(url = '') {
                    let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                    let originalText = bytes.toString(CryptoJS.enc.Utf8);
                    const response = await fetch(url, {
                        method: 'GET', 
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Token ${originalText}`
                        },
                    });
                    return response ? response.json() : console.log('no reponse')
                };

                getData('https://backendpajamas.herokuapp.com/images/').then( response => {
                    setData(response.results)
                })
            }
        }
    }, [reduxDrivers, rotaData, imageData, scheduleData])

    // 

    // // grab the data
    // useEffect(() => {
    //     var CryptoJS = require("crypto-js");
    //     let myDate = new Date()
    //     while (myDate.getDay() > 0) {
    //         myDate.setDate(myDate.getDate() - 1)
    //     }
    //     setSelectedDate(myDate)

    //     axios.get('https://quotes.rest/qod/inspire').then( response => {
    //         setQuoteOfDay(response.data.contents.quotes[0])
    //         setLoadGate(2)
    //     })
    // }, [])

    // map todays booked drivers
    var chart
    useEffect( () => {
        if (schedule) {
            var randomDate 
            randomDate = theDateRandom.toDateString()
            let localNum = 0
            schedule.forEach( (ele, id) => {
                if (ele.date === randomDate.toString() && ele.location === selectedCity) {
                    localNum++
                }
            })
            setTodaysDrivers(
                <h3>Drivers Today at {selectedCity}: {localNum}</h3>
            )
        }
    }, [schedule, selectedCity])

    // set city
    const handleSelectCity = (e, city) => {
        setSelectedCity(city)
    }

    // handling the clock
    useEffect( () => {
        clearInterval(myInterval)
        const timeFunction = () => {
            let setTime = () => {
                setCurrentDate(new Date())
            }
            myInterval = setInterval( setTime, 1000)
        }
        timeFunction()
    }, [])

    var dayArray = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat']
    var monthArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"]

    // eslint-disable-next-line no-extend-native
    Date.prototype.getWeek = function () {
        var firstDate = new Date(this.getFullYear(), 0, 1)
        if (this.getFullYear() === 2021) {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
        } else {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
        }
    }

    // map the verified documents
    useEffect( () => {
        const returnNameVehicle = (identification) => {
            let indexNumber = identification.match(/\d+/)
            return vehicleObj[`${indexNumber}`] ? vehicleObj[`${indexNumber}`] : 'not found'
        }
        const returnNameDriver = (identification) => {
            let indexNumber = identification.match(/\d+/)
            return driversObj[`${indexNumber}`] ? driversObj[`${indexNumber}`].name : 'not found'
        }
        const returnObjectDriver = (identification) => {
            let indexNumber = identification.match(/\d+/)
            return driversObj[`${indexNumber}`] ? driversObj[`${indexNumber}`] : 'not found'
        }
        const returnNameDriverImages = (identification) => {
            let indexNumber = identification.match(/\d+/)
            return driversObj[`${indexNumber}`] ? driversObj[`${indexNumber}`].id : 'not found'
        }
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
            });
            return response ? response.json() : console.log('no reponse')
        };
        let localArray = []
        let expirationDatesArray = []
        let expirationDatesArrayDivs = []
        let rejected = 0
        let approved = 0
        let pending = 0
        let expired = 0
        let offboarded = 0
        let currentLocalDate = new Date()
        let thirtyDaysNotice = currentLocalDate.setDate(currentLocalDate.getDate() + 14)
        let currentLocalDateTwo = new Date()
        let fiveDaysLate = currentLocalDateTwo.setDate(currentLocalDateTwo.getDate() - 1)
        let rightArray = []
        let expiredArray = []
        let dvlaExpired = []
        let pendingArray = []
        if (data) {
            data.forEach( image => {
                if (!image.storageBool) {
                    if (image.verified !== 'offboarded') {
                        // docs for verification part
                        if (image.verified === 'False') {
                            rejected++
                        } else if (image.verified === 'True'){
                            approved++
                        } else if (image.verified === 'offboarded') {
                            offboarded++
                        } else {
                            async function putData(url = '', data={}) {
                                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                                const response = await fetch(url, {
                                    method: 'PUT', 
                                    mode: 'cors',
                                    cache: 'no-cache',
                                    credentials: 'same-origin',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Token ${originalText}`
                                    },
                                    body: JSON.stringify(data)
                                });
                                return response ? response.json() : console.log('no reponse')
                            };
                        
                            // functions for fetching data
                            async function getData(url = '') {
                                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                                const response = await fetch(url, {
                                    method: 'GET', 
                                    mode: 'cors',
                                    cache: 'no-cache',
                                    credentials: 'same-origin',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Token ${originalText}`
                                    },
                                });
                                return response ? response.json() : console.log('no reponse')
                            };
                            if (image.driver_id) {
                                if (returnObjectDriver(image.driver_id)) {
                                    if (returnObjectDriver(image.driver_id).status === 'verified') {
                                        putData(`https://backendpajamas.herokuapp.com/drivers/${returnObjectDriver(image.driver_id).id}/`, {
                                            status: 'Active'
                                        }).then( response => {
                                            getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
                                                // setLoadingMessage('Drivers Arrived')
                                                dispatch(addDrivers(response.results))
                                            })
                                        })
                                    }
                                }
                            }

                            if (image.vehicle_id !== null) {
                                if (returnNameVehicle(image.vehicle_id) !== 'not found') {
                                    pendingArray.push(
                                        <>
                                            <div>
                                                <h3>Vehicle: {returnNameVehicle(image.vehicle_id)}</h3>
                                                <h3>{image.name}</h3>
                                            </div>
                                            <hr />
                                        </>
                                    )
                                }
                            } else {
                                if (returnNameDriver(image.driver_id) !== 'not found') {
                                    pendingArray.push(
                                        <>
                                            <div>
                                                <h3>Name: {returnNameDriver(image.driver_id)}</h3>
                                                <h3>{image.name}</h3>
                                            </div>
                                            <hr />
                                        </>
                                    )
                                }
                            }
                            pending++
                        }
                        if (image.name ==='DVLA Check' && new Date(image.expiryDate) < new Date()) {
                            dvlaExpired.push(image)
                        }
                        if (new Date(image.expiryDate) < thirtyDaysNotice && new Date(image.expiryDate) > fiveDaysLate) {
                            expirationDatesArray.push(image)
                        }
                        if (new Date(image.expiryDate) < new Date() && image.name !== 'DVLA Check' && image.name !== 'D&A test') {
                            if (image.vehicle_id !== null) {
                                if (returnNameVehicle(image.vehicle_id) !== 'not found') {
                                    expiredArray.push(image)
                                    expired++
                                }
                            } else {
                                if (returnNameDriver(image.driver_id) !== 'not found') {
                                    expiredArray.push(image)
                                    expired++
                                }
                            }
                        }
                    }
                }
            })
        }
        localArray.push(
            <div className='docs_for_verification_home'>
                <div className='pending_div'><h3 className='remove_padding'>{pending} Pending</h3>
                    <div className='pendingInnerArrayContainer'>
                        {pendingArray}
                    </div>
                </div>
                <div className='rejected_div'><h3 className='remove_padding'>{rejected} Rejected</h3></div>
                <div className='approved_div'><h3 className='remove_padding'>{approved} Approved</h3></div>
                <div className='expired_div'><h3 className='remove_padding'>{expired} Expired</h3></div>
            </div>
        )
        setVerifiedDocumentsDivs(localArray)
        // localArray.push(
            //     <div className='docs_for_verification_home'>
            //         <div className='rejected_div'><h3 className='remove_padding'>{rejected} Rejected</h3></div>
            //         <div className='approved_div'><h3 className='remove_padding'>{approved} Approved</h3></div>
            //         <div className='pending_div'><h3 className='remove_padding'>{pending} Pending</h3></div>
            //     </div>
            // )
            // setVerifiedDocumentsDivs(localArray)
            // console.log(expirationDatesArray, driversObj, vehicleObj)
        // console.log(expirationDatesArray) 
        expirationDatesArray.sort((a, b) => (new Date(a.expiryDate) > new Date(b.expiryDate) ? 1 : -1))   
        let dbs2Array = []
        let dsn1Array = []
        let dex2Array = []
        let DCF1Array = []
        let dxp1Array = []
        let vehicleArray = []
        expirationDatesArray.forEach( (image, imageID) => {
            if ( image.name !== 'D&A test' && image.name !== 'DVLA Check') {
                if (image.vehicle_id !== null) {
                    if (returnNameVehicle(image.vehicle_id) !== 'not found') {
                        vehicleArray.push(
                            <div className="whiteBox">
                                <h3 className='remove_padding_align'>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                <h3 className='remove_padding_align'>Document Name: {image.name}</h3>
                                <h3 className='remove_padding_align'>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                <br />
                            </div>
                        )
                    }
                } else {
                    if (returnNameDriver(image.driver_id) !== 'not found') {
                        switch (returnObjectDriver(image.driver_id).location) {
                            case "DBS2":
                                dbs2Array.push(
                                    <div className="whiteBox">
                                        <h3 className='remove_padding_align'>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                        <h3 className='remove_padding_align'>Document Name: {image.name}</h3>
                                        <h3 className='remove_padding_align'>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                        <br />
                                    </div>
                                )
                            break;
                            case "DSN1":
                                dsn1Array.push(
                                    <div className="whiteBox">
                                        <h3 className='remove_padding_align'>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                        <h3 className='remove_padding_align'>Document Name: {image.name}</h3>
                                        <h3 className='remove_padding_align'>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                        <br />
                                    </div>
                                )
                                break;
                            case "DEX2":
                                dex2Array.push(
                                    <div className="whiteBox">
                                        <h3 className='remove_padding_align'>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                        <h3 className='remove_padding_align'>Document Name: {image.name}</h3>
                                        <h3 className='remove_padding_align'>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                        <br />
                                    </div>
                                )
                                break;
                            case "DCF1":
                                DCF1Array.push(
                                    <div className="whiteBox">
                                        <h3 className='remove_padding_align'>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                        <h3 className='remove_padding_align'>Document Name: {image.name}</h3>
                                        <h3 className='remove_padding_align'>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                        <br />
                                    </div>
                                )    
                                break;
                            case "DXP1":
                                dxp1Array.push(
                                    <div className="whiteBox">
                                        <h3 className='remove_padding_align'>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                        <h3 className='remove_padding_align'>Document Name: {image.name}</h3>
                                        <h3 className='remove_padding_align'>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                        <br />
                                    </div>
                                )
                                break;
                            default:
                                break;
                        }
                    }
                }
            }
        })
        if (dbs2Array.length > 0) {
            expirationDatesArrayDivs.push(
                <>
                    <h3>DBS2</h3>
                    {dbs2Array}
                </>
            )
        }
        if (dex2Array.length > 0) {
            expirationDatesArrayDivs.push(
                <>
                    <h3>DEX2</h3>
                    {dex2Array}
                </>
            )
        }
        if (dsn1Array.length > 0) {
            expirationDatesArrayDivs.push(
                <>
                    <h3>DSN1</h3>
                    {dsn1Array}
                </>
            )
        }
        if (DCF1Array.length > 0) {
            expirationDatesArrayDivs.push(
                <>
                    <h3>DCF1</h3>    
                    {DCF1Array}
                </>
            )
        }
        if (dxp1Array.length > 0) {
            expirationDatesArrayDivs.push(
                <>
                    <h3>DXP1</h3>
                    {dxp1Array}
                </>
            )
        }
        if (vehicleArray.length > 0) {
            expirationDatesArrayDivs.push(
                <>
                    <h3>Vehicles</h3>
                    {vehicleArray}
                </>    
            )
        }
        setExpirationList(expirationDatesArrayDivs)
        async function awaitDataFunction() {
            const result = Promise.all(expirationDatesArray.map( (image, image_id ) => {
                if (image.name === 'DVLA Check') {
                    if (returnNameDriver(image.driver_id) !== 'not found') {
                        return postData(`https://backendpajamas.herokuapp.com/driverimages/`, {
                            "driver_id": returnNameDriverImages(image.driver_id)
                        }).then ( response => {
                            let dvlaArray = []
                            response.data.forEach( image => {
                                if (image.name === 'DVLA Check') {
                                    dvlaArray.push(image)
                                }
                            })
                            dvlaArray.sort((a, b) => (new Date(a.expiryDate) > new Date(b.expiryDate)) ? 1 : -1)
                            let dvlaDoc = null
                            dvlaDoc = dvlaArray[dvlaArray.length - 1]
                            if (dvlaDoc.image_id === image.image_id) {
                                if (dvlaDoc !== null) {
                                    if (returnNameDriver(image.driver_id) !== 'not found') {
                                        switch (returnObjectDriver(image.driver_id).location) {
                                            case "DBS2":
                                                return ({
                                                    "DBS2": <div className="whiteBox">
                                                                <h3 className='remove_padding_align'>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                                                <h3 className='remove_padding_align'>Document Name: {image.name}</h3>
                                                                <h3 className='remove_padding_align'>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                                                <br />
                                                            </div>
                                                        })
                                            case "DSN1":
                                                return({
                                                    "DSN1": <div className="whiteBox">
                                                                <h3 className='remove_padding_align'>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                                                <h3 className='remove_padding_align'>Document Name: {image.name}</h3>
                                                                <h3 className='remove_padding_align'>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                                                <br />
                                                            </div>
                                                        })
                                            case "DEX2":
                                                return ({
                                                    "DEX2": <div className="whiteBox">
                                                                <h3 className='remove_padding_align'>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                                                <h3 className='remove_padding_align'>Document Name: {image.name}</h3>
                                                                <h3 className='remove_padding_align'>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                                                <br />
                                                            </div>
                                                        })
                                            case "DCF1":
                                                return({
                                                    "DCF1": <div className="whiteBox">
                                                                <h3 className='remove_padding_align'>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                                                <h3 className='remove_padding_align'>Document Name: {image.name}</h3>
                                                                <h3 className='remove_padding_align'>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                                                <br />
                                                            </div>
                                                        })    
                                            case "DXP1":
                                                return({
                                                    "DXP1": <div className="whiteBox">
                                                                <h3 className='remove_padding_align'>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                                                <h3 className='remove_padding_align'>Document Name: {image.name}</h3>
                                                                <h3 className='remove_padding_align'>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                                                <br />
                                                            </div>
                                                        })
                                            default:
                                                break;
                                        }
                                    }
                                }
                            }
                        })
                    }
                }
            }))
            return result
        }
        awaitDataFunction().then( response => {
            let dvlaDbs2 = [<h3>DBS2</h3>]
            let dvlaDex2 = [<h3>DEX2</h3>]
            let dvlaDsn1 = [<h3>DSN1</h3>]
            let dvlaDCF1 = [<h3>DCF1</h3>]
            let dvlaDxp1 = [<h3>DXP1</h3>]

            response.forEach( dvlaEle => {
                // dbs2
                if (dvlaEle !== undefined) {
                    if (dvlaEle.DBS2) {
                        dvlaDbs2.push(
                            <>
                                {dvlaEle.DBS2}
                            </>
                        )
                    }
    
                    // dex2
                    if (dvlaEle.DEX2) {
                        dvlaDex2.push(
                            <>
                                {dvlaEle.DEX2}
                            </>
                        )
                    }
    
                    // dsn1
                    if (dvlaEle.DSN1) {
                        dvlaDsn1.push(
                            <>
                                {dvlaEle.DSN1}
                            </>
                        )
                    }
    
                    // DCF1
                    if (dvlaEle.DCF1) {
                        dvlaDCF1.push(
                            <>
                                {dvlaEle.DCF1}
                            </>
                        )
                    }
    
                    // dxp1
                    if (dvlaEle.DXP1) {
                        dvlaDxp1.push(
                            <>
                                {dvlaEle.DXP1}
                            </>
                        )
                    }
                }
            })
            if (dvlaDbs2.length > 1) {
                rightArray.push(dvlaDbs2)
            }
            if (dvlaDex2.length > 1) {
                rightArray.push(dvlaDex2)
            }
            if (dvlaDsn1.length > 1) {
                rightArray.push(dvlaDsn1)
            }
            if (dvlaDCF1.length > 1) {
                rightArray.push(dvlaDCF1)
            }
            if (dvlaDxp1.length > 1) {
                rightArray.push(dvlaDxp1)
            }
            rightArray.push(<h3>Expired</h3>)
            dvlaExpired.forEach( image => {
                if (image.name === 'DVLA Check') {
                    if (returnNameDriver(image.driver_id) !== 'not found') {
                        postData(`https://backendpajamas.herokuapp.com/driverimages/`, {
                            "driver_id": returnNameDriverImages(image.driver_id)
                        }).then ( response => {
                            let dvlaArray = []
                            response.data.forEach( image => {
                                if (image.name === 'DVLA Check') {
                                    dvlaArray.push(image)
                                }
                            })
                            dvlaArray.sort((a, b) => (new Date(a.expiryDate) > new Date(b.expiryDate)) ? 1 : -1)
                            let dvlaDoc = null
                            dvlaDoc = dvlaArray[dvlaArray.length - 1]
                            if (dvlaDoc.image_id === image.image_id) {
                                if (dvlaDoc !== null) {
                                    if (returnNameDriver(image.driver_id) !== 'not found') {
                                        rightArray.push(
                                            <div className='expiredDvlaContainer'>
                                                <h3 className='remove_padding_align'>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                                <h3 className='remove_padding_align'>Document Name: {image.name}</h3>
                                                <h3 className='remove_padding_align'>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                                <br />
                                            </div>
                                        )
                                    }
                                }
                            }
                        })
                    }
                }
            })
            expirationDatesArrayDivs.push(
                <h3>Expired</h3>
            )
            expiredArray.sort((a, b) => (new Date(a.expiryDate) > new Date(b.expiryDate) ? -1 : 1))
            expiredArray.forEach( image => {
                if (image.name !== 'D&A test' && image.name !== 'DVLA Check') {
                    if (image.vehicle_id !== null) {
                        if (returnNameVehicle(image.vehicle_id) !== 'not found') {
                            expirationDatesArrayDivs.push(
                                <div className='redOverlay'>
                                    <h3 className='remove_padding_align'>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                    <h3 className='remove_padding_align'>Document Name: {image.name}</h3>
                                    <h3 className='remove_padding_align'>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                    <br />
                                </div>
                            )
                        }
                    } else {
                        if (returnNameDriver(image.driver_id) !== 'not found') {
                            expirationDatesArrayDivs.push(
                                <div className='redOverlay'>
                                    <h3 className='remove_padding_align'>{image.vehicle_id !== null ? `Van Registration: ${returnNameVehicle(image.vehicle_id)}` : `Driver: ${returnNameDriver(image.driver_id)}`}</h3>
                                    <h3 className='remove_padding_align'>Document Name: {image.name}</h3>
                                    <h3 className='remove_padding_align'>Expiration Date: {new Date(image.expiryDate).toDateString()}</h3>
                                    <br />
                                </div>
                            )
                        }
                    }
                }
            })
            setQuoteOfDay(rightArray)
            setLoadGate(2)
        })
    }, [data])


    // useEffect( () => {
    //     let localArray = []
    //     if (quoteOfDay) {
    //         localArray.push(
    //             <div>
    //                 <h3 className='remove_padding_align'>{quoteOfDay.quote}</h3>
    //                 <br />
    //                 <h4 className='remove_padding_align'>- {quoteOfDay.author}</h4>
    //             </div>
    //         )
    //     }
    //     setQuoteOfDayArray(localArray)
    // }, [quoteOfDay])

    var content
    if (loadGate > 0) {
        content = (
            <div className='home_content'>
            <NavigationBar title='Home' superUser={props.superUser ? true : false} email={props.user_email}/>
                <div className='main_content_home_two'>
                    <div className='calandar_container'>
                        <div>
                            <div className='home_details'>
                                <h2>Welcome {props.user_name}</h2>
                                {todaysDrivers}
                                <div id="demoHome">
                                    <div className="wrapper">
                                        <div className="content">
                                            <ul>
                                                <a href="#0" onClick={(e, city) => handleSelectCity(e, 'DBS2')}><li>DBS2</li></a>
                                                <a href="#0" onClick={(e, city) => handleSelectCity(e, 'DSN1')}><li>DSN1</li></a>
                                                <a href="#0" onClick={(e, city) => handleSelectCity(e, 'DEX2')}><li>DEX2</li></a>
                                                <a href="#0" onClick={(e, city) => handleSelectCity(e, 'DXP1')}><li>DXP1</li></a>
                                                <a href="#0" onClick={(e, city) => handleSelectCity(e, 'DCF1')}><li>DCF1</li></a>
                                            </ul>
                                        </div>
                                        <div className="parent" >{selectedCity}</div>
                                    </div>
                                </div>
                            </div>
                            <h3 className='home_time'>
                                {dayArray[currentDate.getDay()]}, {currentDate.getDate()} {monthArray[currentDate.getMonth()]}, {currentDate.getFullYear()}
                                <br />
                                {currentDate.toLocaleTimeString()}
                                <br />
                                Week: {currentDate.getWeek()}
                            </h3>
                        </div>
                        <div>
                        </div>
                    </div>
                    <div className='lower_home_page'>
                        <div className='inner_lower_home_container' id='left_one'>
                            <h2>Documents</h2>
                            <div className='docs_for_verification_home_expiration'>
                                {verifiedDocumentsDivs}
                            </div>
                        </div>
                        <div className='inner_lower_home_container' id='center_one'>
                            <h2>Expiring Documents</h2>
                            <div className='docs_for_verification_home_expiration'>
                                {expirationList}
                            </div>
                        </div>
                        <div className='inner_lower_home_container' id="dvlaBottom">
                            <h2>Upcoming DVLA</h2>
                            <div className='docs_for_verification_home_expiration'>
                                {quoteOfDay}
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
        )
    } else {
        content = (
            <div className='home_content'>
            <NavigationBar title='Home' superUser={props.superUser ? true : false}/>
                <div className='containerForLoader'>
                    <div class="spinner">
                        <div class="bounce1"></div>
                        <div class="bounce5"></div>
                        <div class="bounce4"></div>
                        <div class="bounce3"></div>
                        <div class="bounce2"></div>
                    </div>
                </div>
                {/* <div className='bodyWater'>
                    <div class="water">
                        <h1 className='loadingTitle'>
                            H2O Logistics
                        </h1>
                    </div>
                </div> */}
            </div>
        )
    }

    return (
        <>
            {content}
        </>
    )
}

export default HomeTwo
